import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-monatsfolder',
  templateUrl: './monatsfolder.component.html',
  styleUrls: ['./monatsfolder.component.scss']
})
export class MonatsfolderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
